<template>
    <div id="vue-map-widget" class="vue-map-widget">
        <div class="overlay-text" v-html="textAboveMap"></div>

        <map-wrapper
            :focus-regions="mapOptions.focus_regions"
            :mobile-focus-regions="mapOptions.mobile_focus_regions"
            :extra-active-countries="mapOptions.extra_active_countries"
            :extra-active-countries-codes="mapOptions.extra_active_countries_codes"
            :active-country-code="activeCountryCode"
            :domains="domains"
        ></map-wrapper>
    </div>
</template>

<script>
import MapWrapper from "./MapWrapper";

export default {
    name: "MapWidget",

    components: {
        MapWrapper
    },

    props: {
        domains: {
            type: Array,
            default: () => []
        },
        activeCountryCode: {
            type: String,
            default: ''
        },
        textAboveMap: {
            type: String,
            default: ''
        },
        mapOptions: {
            type: Object,
            default: () => {}
        }
    }
}
</script>